import { z } from 'zod'
import { http } from './http'
import { auth } from './auth'
import { parseWithZod } from '../utils/parse-with-zod'

const OneSpanAccessSchema = z.object({
  has_access: z.boolean(),
})

/**
 * OneSpan is not an OAuth provider — there is no authorize URL and no code exchange.
 * Access is a single yes/no lookup against its own `/api/onespan` namespace, and a
 * user without an account has no in-app way to create one.
 */
async function checkAccess({ userId, regionHost }: { userId: number; regionHost?: string }) {
  const host = regionHost ? `${location.protocol}//${regionHost}` : auth.getUserRegionHost()
  const response = await http.post(`${host}/api/onespan/check_access`, {
    user_id: userId,
  })
  return parseWithZod(OneSpanAccessSchema, response)
}

export const onespan = {
  checkAccess,
}
